import { render, staticRenderFns } from "./store-hours.vue?vue&type=template&id=634ba768&scoped=true"
import script from "./store-hours.vue?vue&type=script&lang=js"
export * from "./store-hours.vue?vue&type=script&lang=js"
import style0 from "./store-hours.vue?vue&type=style&index=0&id=634ba768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ba768",
  null
  
)

export default component.exports